import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ClinicalReportPromptVersion, ClinicalReportPromptVersionInput,
} from '../models/clinical-report-prompt-version.model';

export interface IClinicalReportPromptVersionsRepository {
  getAll(): Observable<readonly ClinicalReportPromptVersion[]>;
  create(input: ClinicalReportPromptVersionInput): Observable<ClinicalReportPromptVersion>;
  update(versionId: string, input: ClinicalReportPromptVersionInput): Observable<ClinicalReportPromptVersion>;
  remove(versionId: string): Observable<void>;
  // Answers with the version that just became the default. The previous default is demoted
  // server-side in the same transaction, so callers must re-derive the flag for the whole list
  // rather than flipping it on this one row.
  setDefault(versionId: string): Observable<ClinicalReportPromptVersion>;
}

export const CLINICAL_REPORT_PROMPT_VERSIONS_REPOSITORY =
  new InjectionToken<IClinicalReportPromptVersionsRepository>('IClinicalReportPromptVersionsRepository');
